// 机场健康状态
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Alert, Tag, message } from 'antd'
import { CloseCircleFilled, ExclamationCircleFilled, CloseOutlined, InfoCircleFilled } from '@ant-design/icons'

import { getAirportHealthInfoAPI, airportHealthInfoReadAPI } from '@/server/commandFlight.js'


import Marquee from 'react-fast-marquee';
function AirportHealthStatus (list) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token');
  const { token: { colorBorderSecondary, colorText }, } = theme.useToken(); //获取主题颜色

  const [loading, setLoading] = useState(false)//加载中···

  const msgInterval = useRef()
  const [warningMessage, setWarningMessage] = useState({
    isOpen: false,//打开消息集
    isRead: false,//是否已读
    mainMsg: {},//最主要的消息集
    UAVMsg: [],//无人机消息集
    airportMsg: [],//机场消息集
    ids: [],//所有信息的id集合
  })

  const getAirporintInfo = async () => { //获取机场健康状态
    let war = warningMessage
    let res = await getAirportHealthInfoAPI({ access_token: token, dock_id: list.dock_id })
    if (res.ret !== 200) { message.warning(res.msg || '系统出错啦，请稍后重试！'); return }
    let ids = []
    war.UAVMsg = res.data?.aircraftHms || []
    war.airportMsg = res.data?.dockHms || []
    war.mainMsg = res.data?.mainmsg || {}

    // war.isRead = res.data?.aircraftHms.length > 0 || res.data?.dockHms.length > 0
    res.data?.aircraftHms.forEach((res) => {
      ids.push(res.id)
    })
    res.data?.dockHms.forEach((res) => {
      ids.push(res.id)
    })
    war.ids = ids
    setWarningMessage({ ...war })
  }

  useEffect(() => {
    getAirporintInfo()

    // eslint-disable-next-line
  }, [])


  useEffect(() => {//监听 机场健康状态是否已读
    if (!warningMessage.isRead) {
      msgInterval.current = setInterval(() => {
        getAirporintInfo()
      }, 10000);
    } else {
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }

    return () => {
      // 获取消息集
      clearInterval(msgInterval.current)
      msgInterval.current = null
    }
    // eslint-disable-next-line
  }, [warningMessage.isRead])


  return (
    <div>
      <>{/* 跑马灯 */}
        {
          JSON.stringify(warningMessage.mainMsg) !== '{}' &&
          <div className='w280'>
            <Alert
              showIcon
              icon={
                warningMessage.mainMsg?.level === 0
                  ? <InfoCircleFilled />
                  : warningMessage.mainMsg?.level === 1
                    ? <ExclamationCircleFilled />
                    : warningMessage.mainMsg?.level === 2
                      ? <CloseCircleFilled />
                      : ``
              }
              type={
                warningMessage.mainMsg?.level === 0
                  ? `success`
                  : warningMessage.mainMsg?.level === 1
                    ? `warning`
                    : warningMessage.mainMsg?.level === 2
                      ? `error`
                      : ``
              }
              message={
                <Marquee pauseOnHover gradient={false}>
                  <div
                    className='pointer'
                    onClick={async () => {
                      let war = warningMessage
                      war.mainMsg = {}
                      war.isOpen = true
                      war.isRead = true
                      setWarningMessage({ ...war })
                    }}
                  >
                    {warningMessage.mainMsg?.message_zh}
                  </div>
                </Marquee>
              }
            />
          </div>
        }
      </>

      <>{/* 左侧 详细警告信息 */}
        <div className="pos_fix radius8 w280"
          style={{
            top: '48px', left: '16px',
            background: 'rgba(0,0,0,0.7)',
            display: warningMessage.isOpen ? `` : `none`,
            zIndex: 1,
          }}
        >
          <div className='flex jcr mar4'>
            <CloseOutlined
              className='opa45 pointer'
              onClick={async () => {
                let war = warningMessage
                war.isOpen = false
                war.isRead = false
                setWarningMessage({ ...war })
                let res = await airportHealthInfoReadAPI({
                  access_token: token,
                  ids: warningMessage.ids.join(',')
                })
                if (res.ret !== 200) { message.warning(res.msg || '只读失败') }
                getAirporintInfo()
              }}
            />
          </div>
          <div className='marTB12 marRL16 hidden'
            style={{ maxHeight: 'calc(100vh - 420px)', overflowY: 'auto' }}
          >
            {/* 无人机 */}
            <div style={{ borderBottom: '1px solid ' + colorBorderSecondary, display: warningMessage.UAVMsg.length > 0 ? `` : `none` }}            >
              <Tag className='marB8'>无人机</Tag>
              <div className='marB8'>
                {
                  (warningMessage.UAVMsg || []).map((res, index) => {
                    return (
                      <div className='flex jcsb' key={index}>
                        <div
                          className='marR8'
                          style={{
                            wordBreak: 'break-all',
                            color:
                              res.level === 0
                                ? `rgb(82,196,26)`
                                : res.level === 1
                                  ? `#D89614`
                                  : res.level === 2
                                    ? `#DC4446`
                                    : ``,
                          }}
                        >
                          {res.message_zh}
                        </div>

                        <div className='w55 opa45'>{res.time}</div>
                      </div>
                    )
                  })
                }

              </div>
            </div>

            {/* 机场 */}
            <div
              className='marTB8'
              style={{ display: warningMessage.airportMsg.length > 0 ? `` : `none` }}
            >
              <Tag className='marB8'>机场</Tag>
              <div className='marB8'>
                {
                  (warningMessage.airportMsg || []).map((res, index) => {
                    return (
                      <div className='flex jcsb' key={index}>
                        <div
                          className='marR8'
                          style={{
                            wordBreak: 'break-all',
                            color:
                              res.level === 0
                                ? `rgb(82,196,26)`
                                : res.level === 1
                                  ? `#D89614`
                                  : res.level === 2
                                    ? `#DC4446`
                                    : ``,
                          }}
                        >
                          {res.message_zh}
                        </div>

                        <div className='w55 opa45'>{res.time}</div>
                      </div>
                    )
                  })
                }
              </div>

            </div>
          </div>
        </div>
      </>

    </div>
  )
}
export default AirportHealthStatus;